import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isLoading: false,
  stopWizard: false,
  subjectType: null,
  danovnikYear: null,
  rezident: null,
  activeMembership: 1,
  domain: null,
  lastIndex: null,
  canToast: true,

  skNace: [],
  kraj: [],
  zahKraj: [],
  kurzy: {},

  idSupported: null
}

const getters = {}

const actions = {}

const mutations = {
  startLoader() {
    state.isLoading = true
  },
  stopLoader() {
    state.isLoading = false
  },

  noToast () {
    state.canToast = false
  },
  toastable () {
    state.canToast = true
  },
  nerezident(state, item) {
    state.rezident = item
  },

  setIdSupported(state, payload) {
    state.idSupported = payload
    state.danovnikYear = payload
  },
  stopWizard(state, payload) {
    state.stopWizard = payload
  },

  setType(state, item) {
    state.subjectType = item
  },
  setDomain(state, item) {
    state.domain = item
  },
  setNace(state, item) {
    state.skNace = item
  },
  setKraj(state, item) {
    state.kraj = item
  },
  setKurz(state, item) {
    state.kurzy = item
  },
  setZahKraj(state, item) {
    state.zahKraj = item
  },
  setMembership(state, payload) {
    state.activeMembership = payload
  },
  setLastIndex(state, payload) {
    state.lastIndex = payload
  },
};

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  actions,
  mutations
})
